exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".grid-accordion__header{display:grid;grid-template-columns:1fr 10px;align-items:center}.grid-accordion .header__icon{will-change:transform;transition:transform .25s ease-out}.grid-accordion .header__icon--rotate{transform:rotate(180deg)}body[dir=rtl] .grid-accordion .header__icon--rotate {\n  transform: rotate(-180deg);\n}\n", ""]);

// exports
